import {
  mdiAccessPoint,
  mdiAlertOutline,
  mdiAlertRhombusOutline,
  mdiArchiveAlertOutline,
  mdiArrowDecision,
  mdiArrowExpandAll,
  mdiAvTimer,
  mdiAxisZRotateCounterclockwise,
  mdiBusClock,
  mdiCameraIris,
  mdiCarMultiple,
  mdiChartArc,
  mdiChartBarStacked,
  mdiChartBellCurve,
  mdiChartBoxOutline,
  mdiChartPie,
  mdiChartTimeline,
  mdiCircleSlice2,
  mdiClockAlertOutline,
  mdiClockDigital,
  mdiClockOutline,
  mdiCogOutline,
  mdiCogs,
  mdiCreditCardClockOutline,
  mdiCrosshairs,
  mdiDiceD20Outline,
  mdiLightbulbOnOutline,
  mdiMapOutline,
  mdiMidiPort,
  mdiMonitorDashboard,
  mdiMonitorEye,
  mdiNumeric10BoxMultipleOutline,
  mdiRecycleVariant,
  mdiScoreboardOutline,
  mdiSpeedometer,
  mdiSpeedometerSlow,
  mdiSync,
  mdiTableRefresh,
  mdiTimetable,
  mdiTransmissionTower,
  mdiWeatherNight,
  mdiWifiLock,
} from '@mdi/js'
import Icon from '@mdi/react'
import NavRoutes from '../../common/NavRoutes'

export default [
  {
    id: 'junctionParameters',
    title: 'Junction Parameters',
    icon: <Icon path={mdiCrosshairs} size={1} />,
    children: [
      {
        id: 'specifications',
        title: 'Specifications',
        children: [
          {
            id: 'phaseFlow',
            title: 'Phase Flow',
            navLink: NavRoutes.phaseFlow,
            icon: <Icon path={mdiArrowDecision} size={1} />,
          },
          {
            id: 'signalOutput',
            title: 'Signal Output',
            navLink: NavRoutes.signalOutput,
            icon: <Icon path={mdiArrowExpandAll} size={1} />,
          },
          {
            id: 'phaseDemand',
            title: 'Phase Demand',
            navLink: NavRoutes.phaseDemand,
            icon: <Icon path={mdiChartBoxOutline} size={1} />,
          },
          {
            id: 'phaseConfig',
            title: 'Phase Config',
            navLink: NavRoutes.phaseConfig,
            icon: <Icon path={mdiRecycleVariant} size={1} />,
          },
          {
            id: 'systemInputs',
            title: 'System Inputs',
            navLink: NavRoutes.systemInputs,
            icon: <Icon path={mdiMidiPort} size={1} />,
          },
        ],
      },

      {
        id: 'junctionControl',
        title: 'Junction Control',
        children: [
          {
            id: 'systemGeneralSetting',
            title: 'System General Setting',
            navLink: NavRoutes.systemGeneralSetting,
            icon: <Icon path={mdiCogOutline} size={1} />,
          },
          {
            id: 'faultMonitoring',
            title: 'Fault Monitoring',
            navLink: NavRoutes.faultMonitoring,
            icon: <Icon path={mdiAlertRhombusOutline} size={1} />,
          },
          {
            id: 'generalTimeParameters',
            title: 'General Time Parameters',
            navLink: NavRoutes.generalTimeParameters,
            icon: <Icon path={mdiTimetable} size={1} />,
          },
          {
            id: 'nightFlashing',
            title: 'Night Flashing',
            navLink: NavRoutes.nightFlashing,
            icon: <Icon path={mdiWeatherNight} size={1} />,
          },
          {
            id: 'streetLight',
            title: 'Street Light',
            navLink: NavRoutes.streetLight,
            icon: <Icon path={mdiLightbulbOnOutline} size={1} />,
          },
          {
            id: 'advanceControlSetting',
            title: 'Advance Control Setting',
            navLink: NavRoutes.advanceControlSetting,
            icon: <Icon path={mdiCogs} size={1} />,
          },
        ],
      },

      {
        id: 'trafficTimer',
        title: 'Traffic Timer',
        children: [
          {
            id: 'countdownMode',
            title: 'Countdown Assignment',
            navLink: NavRoutes.countdownMode,
            icon: <Icon path={mdiNumeric10BoxMultipleOutline} size={1} />,
          },
          {
            id: 'countdownSetting',
            title: 'Countdown Setting',
            navLink: NavRoutes.countdownSetting,
            icon: <Icon path={mdiDiceD20Outline} size={1} />,
          },
        ],
      },
    ],
  },
  {
    id: 'synchronization',
    title: 'J2J Synchronization',
    icon: <Icon path={mdiSync} size={1} />,
    children: [
      {
        id: 'parameters',
        title: 'Parameters',
        children: [
          {
            id: 'goGreen',
            title: 'Go-Green',
            navLink: NavRoutes.goGreen,
            icon: <Icon path={mdiAccessPoint} size={1} />,
          },
          {
            id: 'forcePhase',
            title: 'Force Phase',
            navLink: NavRoutes.forcePhase,
            icon: <Icon path={mdiAxisZRotateCounterclockwise} size={1} />,
          },
          {
            id: 'transmitLockingSignal',
            title: 'Transmit Locking Signal',
            navLink: NavRoutes.transmitLockingSignal,
            icon: <Icon path={mdiWifiLock} size={1} />,
          },
          {
            id: 'transmitForcingSignal',
            title: 'Transmit Forcing Signal',
            navLink: NavRoutes.transmitForcingSignal,
            icon: <Icon path={mdiTransmissionTower} size={1} />,
          },
          {
            id: 'timeWindows',
            title: 'Time Windows',
            navLink: NavRoutes.timeWindows,
            icon: <Icon path={mdiScoreboardOutline} size={1} />,
          },
        ],
      },
    ],
  },
  {
    id: 'timeConfiguration',
    title: 'Time Configuration',
    icon: <Icon path={mdiClockDigital} size={1} />,
    navLink: '#',
    children: [
      {
        id: 'va-time',
        title: 'VA Time',
        navLink: '#',
        children: [
          {
            id: 'vaTime',
            title: 'VA Time',
            navLink: NavRoutes.vaTime,
            icon: <Icon path={mdiBusClock} size={1} />,
          },
        ],
      },
      {
        id: 'multiplan',
        title: 'Multiplan',
        navLink: '#',
        children: [
          {
            id: 'fixTime',
            title: 'Fix Time',
            navLink: NavRoutes.fixTime,
            icon: <Icon path={mdiChartTimeline} size={1} />,
          },
          {
            id: 'maxTime',
            title: 'VA Max Time',
            navLink: NavRoutes.maxTime,
            icon: <Icon path={mdiSpeedometer} size={1} />,
          },
          {
            id: 'minTime',
            title: 'VA Min Time',
            navLink: NavRoutes.minTime,
            icon: <Icon path={mdiSpeedometerSlow} size={1} />,
          },
          {
            id: 'gapTime',
            title: 'VA Gap Time',
            navLink: NavRoutes.gapTime,
            icon: <Icon path={mdiAvTimer} size={1} />,
          },
        ],
      },
      {
        id: 'junctionClock',
        title: 'Junction Clock',
        navLink: '#',
        children: [
          {
            id: 'clockSetting',
            title: 'Clock Setting',
            navLink: NavRoutes.clockSetting,
            icon: <Icon path={mdiClockOutline} size={1} />,
          },
        ],
      },
    ],
  },
  {
    id: 'site-operation',
    title: 'Site Operation',
    icon: <Icon path={mdiMonitorEye} size={1} />,
    children: [
      {
        id: 'site-operation1',
        title: 'Site Operation',
        children: [
          {
            id: 'overseeMode',
            title: 'Dynamic Mode',
            navLink: NavRoutes.overseeMode,
            icon: <Icon path={mdiMonitorDashboard} size={1} />,
          },
          {
            id: 'geographicalView',
            title: 'Geographical View',
            navLink: NavRoutes.mapView,
            icon: <Icon path={mdiMapOutline} size={1} />,
          },
        ],
      },
      {
        id: 'cctv',
        title: 'CCTV on Site',
        children: [
          {
            id: 'rtsp',
            title: 'CCTV View',
            navLink: NavRoutes.rtsp,
            icon: <Icon path={mdiMonitorDashboard} size={1} />,
          },
        ],
      },
    ],
  },
  {
    id: 'green-time-ledger',
    title: 'Green Time Ledger',
    navLink: '#',
    icon: <Icon path={mdiChartPie} size={1} />,
    children: [
      {
        id: 'green-time-sub',
        title: 'Green Time',
        children: [
          {
            id: 'phasePerspective',
            title: 'Phase Perspective',
            navLink: NavRoutes.greenTimeLedgerPhase,
            icon: <Icon path={mdiCircleSlice2} size={1} />,
          },
          {
            id: 'cyclePerspective',
            title: 'Cycle Perspective',
            navLink: NavRoutes.greenTimeLedgerCycle,
            icon: <Icon path={mdiChartArc} size={1} />,
          },
        ],
      },
    ],
  },
  {
    id: 'vehicle-vol-ledger',
    title: 'Vehicle Volume Ledger',
    navLink: '#',
    icon: <Icon path={mdiCarMultiple} size={1} />,
    children: [
      {
        id: 'vehicle-vol-sub',
        title: 'Vehicle Volume',
        children: [
          {
            id: 'phasePerspectiveVeh',
            title: 'Phase Perspective',
            navLink: NavRoutes.vehicleVolumeLedgerPhase,
            icon: <Icon path={mdiCircleSlice2} size={1} />,
          },
          {
            id: 'cyclePerspective Veh',
            title: 'Cycle Perspective',
            navLink: NavRoutes.vehicleVolumeLedgerCycle,
            icon: <Icon path={mdiChartArc} size={1} />,
          },
        ],
      },
    ],
  },
  {
    id: 'contemporaryStatus',
    title: 'Contemporary Status',
    icon: <Icon path={mdiTableRefresh} size={1} />,
    children: [
      {
        id: 'contemporaryStatusMode',
        title: 'Phase Aggregation',
        children: [
          {
            id: 'phaseAggregation',
            title: 'Phase Aggregation',
            navLink: NavRoutes.phaseAggregation,
            icon: <Icon path={mdiCameraIris} size={1} />,
          },
        ],
      },
      {
        id: 'individualCycle',
        title: 'Individual Cycle',
        children: [
          {
            id: 'veh-vol',
            title: 'Traffic Magnitude',
            navLink: NavRoutes.trafficMagnitude,
            icon: <Icon path={mdiChartBellCurve} size={1} />,
          },
          {
            id: 'green-time',
            title: 'Green Time',
            navLink: NavRoutes.greenTime,
            icon: <Icon path={mdiChartBarStacked} size={1} />,
          },
          {
            id: 'waiting-time',
            title: 'Vehicle Waiting Time',
            navLink: NavRoutes.waitingTime,
            icon: <Icon path={mdiCreditCardClockOutline} size={1} />,
          },
        ],
      },
    ],
  },
  {
    id: 'alarms',
    title: 'Alarms',
    icon: <Icon path={mdiAlertOutline} size={1} />,
    children: [
      {
        id: 'sub-alarms',
        title: 'Alarms and Events',
        children: [
          {
            id: 'recentAlarm',
            title: 'Recent Alarm',
            navLink: NavRoutes.recentAlarm,
            icon: <Icon path={mdiClockAlertOutline} size={1} />,
          },
          {
            id: 'alarmArchive',
            title: 'Alarm Archive',
            navLink: NavRoutes.alarmArchive,
            icon: <Icon path={mdiArchiveAlertOutline} size={1} />,
          },
        ],
      },
    ],
  },
]
